import React from 'react';
import moment from 'moment';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import { getLocationColor, getLocationEmoji } from '../../helpers/locations';
import { formatPatientName } from '../../helpers/patients';

/**
 * Renders a single appointment block overlayed on the week grid.
 * Expects appointment: { start, end, backgroundColor, title? }
 * and style: { top, left, width, height } in pixels.
 */
const CalendarWeekAppointment = ({ 
  session, 
  style,
  onClick = () => console.log('Clicked session', session),
}) => {
  if (!session || !style) return null;

  const startDate = (
    typeof session.date === 'string' 
    ? new Date(session.date) 
    : session.date
  );
  const timeLabel = startDate.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
  const locationCategory = (
    session?.appointment_scheduled?.session_type?.location_type
    || session?.session_type?.location_type
  );
  const backgroundColor = getLocationColor(locationCategory);
  const opacity = moment(session.date).isBefore(moment()) ? 0.75 : 1;

  return (
    <Box
      style={{
        cursor: 'pointer',
        position: 'absolute',
        top: style.top,
        left: style.left,
        width: style.width,
        height: style.height,
        backgroundColor,
        color: 'white',
        fontWeight: 700,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxSizing: 'border-box',
        zIndex: 2,
        opacity,
      }}
      sx={{
        borderRadius: 2,
        pt: 0.5,
        pr: 1,
        pl: 1,
        pb: 0.5,
        boxShadow: 1,
        '&:hover': {
          opacity: 0.9,
          boxShadow: 2,
        },
      }}
      onClick={e => onClick(e, session.id)}
    >
      <Stack direction='row' justifyContent='space-between'>
        <Typography 
          variant="caption" 
          sx={{ fontWeight: 700, color: 'white', lineHeight: 0.9 }}
        >
          {timeLabel}
        </Typography>
        <Typography>{getLocationEmoji(locationCategory)}</Typography>
      </Stack>
      {!!session.patient && 
        <Typography
          variant="caption"
          sx={{
            fontWeight: 500,
            color: 'white',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            lineHeight: 0.9,
            m: 0,
            p: 0,
          }}
        >
          {formatPatientName(session.patient)}
        </Typography>
      }
    </Box>
  );
};

export default CalendarWeekAppointment;
